import {InputHTMLAttributes, TextareaHTMLAttributes} from "react";
import {Props as ReactSelectProps} from "react-select";

export type PropsWithOverwrite<T1, T2> = Omit<T1, keyof T2> & T2;

export type HTMLInputElementProps = InputHTMLAttributes<HTMLInputElement>;
export type HTMLTextAreaElementProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export type CommonInputProps<T> = {
    value: T | undefined;
    onChange: (value: T) => void;
    small?: boolean;
    cssClass?: string;
}
export type ReactSelectPropsWithOverwrite<T> = PropsWithOverwrite<ReactSelectProps, T>;

export const getValidityErrorKey = (validity: ValidityState): string => {
    if (!validity || validity.valid) return "";

    switch (true) {
        case validity.valueMissing:
            return "error.required";
        case validity.badInput:
        case validity.patternMismatch:
            return "error.invalid";
        case validity.typeMismatch:
            return "error.invalid";
        case validity.rangeOverflow:
        case validity.rangeUnderflow:
        case validity.stepMismatch:
            return "error.not_allowed";
        case validity.tooLong:
            return "error.too_long";
        case validity.tooShort:
            return "error.too_short";
        default:
            return "";
    }
};
